
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartTooltip } from "./ChartTooltip";

interface PieDataPoint {
  name: string;
  value: number;
}

const COLORS = [
  "#c9a84c", "#7c9a5e", "#d4816b", "#6b8fd4",
  "#b07cc9", "#e8c36a", "#5a9e8f", "#a89f93",
];

function fmt(n: number) {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return n.toLocaleString("cs-CZ");
}

interface PieChartCardProps {
  title: string;
  data: PieDataPoint[];
}

export function PieChartCard({ title, data }: PieChartCardProps) {
  const total = data.reduce((s, d) => s + d.value, 0);

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm">{title}</CardTitle>
      </CardHeader>
      <CardContent className="pb-3">
        <div className="flex gap-4 items-center">
          {/* Chart */}
          <div className="h-[140px] w-[140px] flex-shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={data} cx="50%" cy="50%" innerRadius={35} outerRadius={60} paddingAngle={2} dataKey="value">
                  {data.map((_, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip content={<ChartTooltip isDate={false} />} />
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Legend with numbers */}
          <div className="flex-1 space-y-1.5 min-w-0">
            {data.map((item, i) => {
              const pct = total > 0 ? (item.value / total * 100).toFixed(1) : "0";
              return (
                <div key={item.name} className="flex items-center gap-2 text-xs">
                  <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: COLORS[i % COLORS.length] }} />
                  <span className="truncate text-muted-foreground flex-1">{item.name}</span>
                  <span className="font-semibold tabular-nums">{fmt(item.value)}</span>
                  <span className="text-muted-foreground tabular-nums w-[40px] text-right">{pct}%</span>
                </div>
              );
            })}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
